import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'
import '@/assets/style/reset.css'
import '@/assets/style/common.css'
import locale from 'element-plus/lib/locale/lang/zh-cn'



createApp(App).use(store).use(router).use(ElementPlus, { locale }).mount('#app')
